module.exports = __webpack_public_path__ + "media/images/brand/logo/farworks_amoeba_large-786ce5d7c891d8574f139c7e69b4ed31.png";